import type {
  AdminProviderReportDto,
  CreateProviderReportDto,
  ProviderReportFormValues,
  ProviderReportReason,
  ProviderReportStatus,
  SubmittedProviderReportDto,
} from './provider-reports.dto';

export const PROVIDER_REPORT_REASON_LABELS: Record<ProviderReportReason, string> = {
  spam: 'Spam',
  fraud_or_scam: 'Fraud or Scam',
  inappropriate_content: 'Inappropriate Content',
  misleading_information: 'Misleading Information',
  poor_service_quality: 'Poor Quality of Work',
  unprofessional_behavior: 'Unprofessional Behavior',
  other: 'Other',
};

export const PROVIDER_REPORT_STATUS_LABELS: Record<ProviderReportStatus, string> = {
  new: 'New',
  in_review: 'In Review',
  resolved: 'Resolved',
  dismissed: 'Dismissed',
};

/** Still waiting on a decision — the service allows only one such report per user and provider. */
export const isOpenProviderReport = ({ status }: { status: ProviderReportStatus }) =>
  status === 'new' || status === 'in_review';

export type SubmittedProviderReport = {
  id: string;
  serviceProviderId: string;
  serviceProviderName: string;
  reason: ProviderReportReason;
  details: string | null;
  status: ProviderReportStatus;
  createdAt: string;
};

export type AdminProviderReport = SubmittedProviderReport & {
  reporterId: string;
  serviceId: string;
  updatedAt: string;
};

export const mapSubmittedProviderReport = ({
  id,
  service_provider_id,
  service_provider_name,
  reason,
  details,
  status,
  created_at,
}: SubmittedProviderReportDto): SubmittedProviderReport => ({
  id,
  serviceProviderId: service_provider_id,
  serviceProviderName: service_provider_name,
  reason,
  details,
  status,
  createdAt: created_at,
});

export const mapAdminProviderReport = (dto: AdminProviderReportDto): AdminProviderReport => ({
  ...mapSubmittedProviderReport(dto),
  reporterId: dto.reporter_id,
  serviceId: dto.service_id,
  updatedAt: dto.updated_at,
});

// A blank comment is left off the wire rather than sent as an empty string.
export const mapProviderReportToDto = ({
  reason,
  details,
}: ProviderReportFormValues): CreateProviderReportDto => ({
  reason,
  details: details || undefined,
});
